<template>
    <div class="wrap">
        <!-- 确定取消按钮 -->
        <!-- <div class="wrap_btn">
            <van-button style="width: 48%;" round color="#3B7CFF" @click="casLogin">确定</van-button>
        </div> -->

    </div>
</template>
<script>
import moment from 'moment'
export default {
    data() {
        return {
            ticket: ''
        }
    },
    created() {
        // 获取票据
        this.ticket = this.getQueryParam('ticket')

        // 登录
        this.casLogin()


    },
    // 函数对象
    methods: {

        async casLogin() {
            console.log('this.ticket',this.ticket)
            // return 
            const { code, data } = await this.$https.casLogin({ticket: this.ticket})
            console.log('code,data',code,data)

            if (code != 200) {
                this.$router.go(-2)
                return
            }
            if (!data) {
                this.$router.go(-2)
                return
            }
            // 保存获取的cas登录token
            localStorage.setItem('cas_token',data.token)
            localStorage.setItem('token',data.token)
            localStorage.setItem('cas_userInfo',JSON.stringify(data))
            this.$router.push('/roomAppointment');
            // if (data.personType == 13) {
            //     this.$router.push('/roomApproval');
            // } else if (data.personType == 11) {
            //     this.$router.push('/roomAppointment');
            // }
        },

        // 获取地址栏参数
        getQueryParam(paramName) {
            const regex = new RegExp('[?&]' + paramName + '=([^&#]*)');
            const results = regex.exec(window.location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }


    }
}
</script>

<style lang="scss" scoped></style>